import type { ComponentProps, ReactNode } from "react";
import { type ExtraProps } from "react-markdown";

export function removeParagraphImageWrapper({ node, children }: ComponentProps<"p"> & ExtraProps): ReactNode {
  const hasOnlyImages = node?.children?.every(
    (child) => (child.type === "element" && child.tagName === "img") || (child.type === "text" && !child.value.trim())
  );

  if (hasOnlyImages) return <>{children}</>;

  return <p>{children}</p>;
}
